export const statusConst = {
  courtType: {
    primary: 1,
    advance: 2, 
  },

  fileType: {
    pdf: 'pdf',
    word: 'doc',
    word2: 'docx',
    jpg: 'jpg',
    png: 'png',
    jpeg: 'jpeg',
    file: 'File',
  },
  userStatus: {
    plantiff: 1,
    representative: 2,
    both: 3,
  },
  fillingAsConst: {
    plantiff: 1, //ผู้ฟ้อง
    representative: 2, //ผู้แทน
    both: 3,//ผู้ฟ้อง และ ผู้แทน
    defendand: 4, //ผู้ถูกฟ้อง
    defenRepresen: 5, //ผู้ถูกฟ้อง และ ผู้แทน
    inserter: 6, //ผู้สอด
    stakeholder: 7, //ผู้มีส่วนได้ส่วนเสีย
    appealent:8,//ผู้อุทธรณ์
    appealentAttorney:9,//ผู้อุทธรณ์และผู้รับมอบอำนาจ/ผู้แทน
    appealentParties:10,//คู่กรณีในอุทธรณ์
    appealentPartiesAttorney:11,//คู่กรณีในอุทธรณ์และผู้รับมอบอำนาจ/ผู้แทน

    Petitioner:12,//ผู้ร้อง
    PetitionerAttorney:13,//ผู้ร้อง/ผู้รับมอบอำนาจ/ผู้แทน
    opposer:14,//ผู้คัดค้าน
    opposerAttorney:15,//ผู้คัดค้าน/ผู้รับมอบอำนาจ/ผู้แทน
  },
  representativeConst: {
    plantiff: 1, //ผู้ฟ้อง
    representative: 2, //ผู้ถูกฟ้อง 
    inserter: 3, //ผู้สอด
    stakeholder: 4, //ผู้มีส่วนได้ส่วนเสีย
    appealent:5,//ผู้อุทธรณ์
    appealentParties:6,//คู่กรณีในอุทธรณ์
    Petitioner:7,//ผู้ร้อง
    opposer:8,//ผู้คัดค้าน
  },
  foundationTypeEnum: {
    indictment: 45,
    testimony: 42,
    modifyTestimony: 42,
    expandTestimony: 42,
    trial: 156,
    draft: 149
  },
  fdt_Id_Enum: {
    indictment: 45, //คำฟ้อง
    indicmtnet_amend: 115,//คำขอแก้ไขเพิ่มเติมคำฟ้อง 115,
    draft: 149,//ร่างคำตอบรับการใช้ระบบงานคดีปกครองอิเล็กทรอนิกส์

    testimoy: 42, //คำให้การ
    testimony_amend: 116,//คำแก้ไขเพิ่มเติมคำให้การเพิ่มเติม
    testimony_extend: 150,//คำขอขยายระยะเวลาทำคำให้การ

    objection: 43,//คำคัดค้านคำให้การ 43,
    objection_amend: 117,//ยื่อคำขอแก้ไขเพิ่มเติมคำคัดค้านคำให้การ
    objection_extend: 151,//คำขอขยายระยะเวลาทำคำคัดค้านคำให้การ

    additional: 44,//คำให้การเพิ่มเติม 116,
    additional_amend: 102,//ยื่นคำขอแก้ไขเพิ่มเติมคำให้การเพิ่มเติม
    additional_extend: 152,//ยื่นคำขอขยายระยะเวลาทำคำให้การเพิ่มเติม

    temporary: 4,//คำขอวิธีการชั่วคราว 4,
    other: 40,//คำขออื่นๆ
    statement: 47,//ยื่นคำแถลง
    explain: 46,//ยื่นคำชี้แจง
    courtfees_except: 144,//ยื่นขอยกเว้นค่าธรรมเนียมศาล	 
    courtfees_pay: 123,//ชำระค่าธรรมเนียมศาล	 
    courtfees_return: 21,//ยื่นขอคืนค่าธรรมเนียมศาล	 
    courtfees_relay: 129,//ยื่นขอผัดส่งค่าธรรมเนียมศาล	 
    trial: 156, //คำขอพิจารณาคดี ออนไลน์ 

    appeal:66,//คำอุทธรณ์
    editAdditionalAppeal:127,//คำขอแก้ไขเพิ่มเติมคำอุทธรณ์
    appealOrder:126,//คำร้องอุทธรณ์คำสั่ง
    appealOrderEdit:159,//ขอแก้ไขเพิ่มเติมคำร้องอุทธรณ์คำสั่ง
    appealOrderExtension:161,//คำขอขยายระยะเวลา-คำร้องอุทธรณ์คำสั่ง

    editAppeal:106,//คำแก้อุทธรณ์
    editAppealAmend:163,//คำขอแก้ไขเพิ่มเติมคำแก้อุทธรณ์
    editAppealExtension:162,//คำขอขยายระยะเวลา-คำแก้อุทธรณ์
    finalCaseNum:168,//คำขอหนังสือคดีถึงที่สุด

    mediate_request:154, //คำขอให้มีการไกล่เกลี่ยข้อพิพาท
    mediate_agree:155, //หนังสือแสดงความตกลงหรือยินยอมให้มีการไกล่เกลี่ยข้อพิพาท
    mediate_postponement:169, //ยื่นคำขอเลื่อนนัด

    checkcopy_check:7, //ยื่นคำขอตรวจสำนวน
    checkcopy_copy:6, //ยื่นคำขอคัดสำเนา

  },
  uploadFileEnum: {
    indictmentLitigants: 0, //ผู้ฟ้องคดี
    indictmentLitigantsPdfWord: 2,
    indictmentLitigantsDoc: 29,

    indictmentDelegates: 36, //ผู้รับมอบอำนาจ/ผู้แทน
    indictmentDelegatesPdfWord: 2,
    indictmentDelegatesDoc: 29,

    indictmentLitigantsDelegates: 36, //ผู้ฟ้องคดีและผู้รับมอบอำนาจ/ผู้แทน
    indictmentLitigantsDelegatesPdfWord: 2,
    indictmentLitigantsDelegatesDoc: 29,

    indicmtnet_amend: 36,//คำขอแก้ไขเพิ่มเติมคำฟ้อง
    indicmtnet_amendPdfWord: 78,
    indicmtnet_amendDoc: 35,

    testimoy: 36, //คำให้การ
    testimoyPdfWord: 3,
    testimoyDoc: 30,

    testimonyAmend: 36, //คำขอแก้ไขเพิ่มเติมคำให้การ
    testimonyAmendPdfWord: 79,
    testimonyAmendDoc: 138,

    testimonyExtend: 36, //คำขอขยายระยะเวลา
    testimonyExtendPdfWord: 59,
    testimonyExtendDoc: 35,

    objection: 36, //คำคัดค้านคำให้การ
    objectionPdfWord: 4,
    objectionDoc: 31,

    objectionAmend: 36, //คำแก้ไขเพิ่มเติมคำคัดค้านคำให้การ
    objectionAmendPdfWord: 80,
    objectionAmendDoc: 139,

    objectionExtend: 36, //คำขอขยายระยะเวลา
    objectionExtendPdfWord: 59,
    objectionExtendDoc: 35,

    additional: 36,//คำให้การเพิ่มเติม
    additionalPdfWord: 5,
    additionalDoc: 32,

    additionalAmend: 36,//คำขอแก้ไขเพิ่มเติมคำให้การเพิ่มเติม
    additionalAmendPdfWord: 81,
    additionalAmendDoc: 140,

    additionalExtend: 36,//คำขอขยายระยะเวลา
    additionalExtendPdfWord: 59,
    additionalExtendDoc: 35,

    other: 36, //ยื่นคำขออื่นๆ
    otherPdfWord: 59,
    otherDoc: 35,

    temporary: 36, //ขอวิธีการชั่วคราว
    temporaryPdfWord: 59,
    temporaryDoc: 35,

    statement: 36, //คำแถลง
    statementPdfWord: 7,
    statementDoc: 117,

    explain: 36, //คำชี้แจง
    explainPdfWord: 6,
    explainDoc: 33,

    waived: 36,//ขอยกเว้นค่าธรรมเนียมศาล
    waivedPdfWord: 59,
    waivedDoc: 35,

    refund: 36,//ขอคืนค่าธรรมเนียมศาล
    refundPdfWord: 59,
    refundDoc: 35,

    taketurn: 36,//ขอคืนค่าธรรมเนียมศาล
    taketurnPdfWord: 59,
    taketurnDoc: 35,

    conferencing:36,//ยื่นคำขอพิจารณาคดีโดยวิธีการทางอิเล็กทรอนิกส์หรือระบบการประชุมทางจอภาพ

    express:36,//คำตอบรับการใช้ระบบงานคดีปกครองอิเล็กทรอนิกส์

    appeal:66,//คำอุทธรณ์
    appealPdfWord: 66,
    appealDoc: 66,

    editAdditionalAppeal:127,//คำขอแก้ไขเพิ่มเติมคำอุทธรณ์
    editAdditionalAppealPdfWord: 127,
    editAdditionalAppealDoc: 127,

    appealOrder:126,//คำร้องอุทธรณ์คำสั่ง
    appealOrderPdfWord: 126,
    appealOrderDoc: 126,

    appealOrderEdit:159,//ขอแก้ไขเพิ่มเติมคำร้องอุทธรณ์คำสั่ง
    appealOrderEditPdfWord: 159,
    appealOrderEditDoc: 159,

    appealOrderExtension:161,//คำขอขยายระยะเวลา-คำร้องอุทธรณ์คำสั่ง
    appealOrderExtensionPdfWord: 161,
    appealOrderExtensionDoc: 161,

    editAppeal:106,//คำแก้อุทธรณ์
    editAppealPdfWord:106,
    editAppealDoc:106,

    editAppealAmend:163,//คำขอแก้ไขเพิ่มเติมคำแก้อุทธรณ์
    editAppealAmendPdfWord:163,
    editAppealAmendDoc:163,

    editAppealExtension:162,//คำขอขยายระยะเวลา-คำแก้อุทธรณ์
    editAppealExtensionPdfWord:163,
    editAppealExtensionDoc:163,
    finalCaseNum:168,//คำขอหนังสือคดีถึงที่สุด

    mediate_request: 36, //คำขอให้มีการไกล่เกลี่ยข้อพิพาท
    mediate_requestPdfWord: 59,  // คำขอ
    mediate_requestDoc: 35,

    mediate_agree: 36, //หนังสือแสดงความตกลงหรือยินยอมให้มีการไกล่เกลี่ยข้อพิพาท
    mediate_agreePdfWord: 59, // คำขอ
    mediate_agreeDoc: 35,

    mediate_postponement: 36, //ยื่นคำขอเลื่อนนัด
    mediate_postponementPdfWord: 59,  // คำขอ
    mediate_postponementDoc: 35,
    
    checkcopy_check: 36, // มอบอำนาจ FOUNDATION
    checkcopy_checkPdfWord: 59, // คำขอ FOUNDATION
    checkcopy_checkDoc: 35, // เอกสารประกอบคำขอ FOUNDATION

    checkcopy_copy: 36, // มอบอำนาจ FOUNDATION
    checkcopy_copyPdfWord: 59, // คำขอ FOUNDATION
    checkcopy_copyDoc: 35,  // เอกสารประกอบคำขอ FOUNDATION

  },
  payMethod: {
    gateway : 5,
    pagetopage :6,
    netbank : 7,
    bill:2
  },

  paymentPath:{
    payFee:1,//หน้าชำระค่าธรรมเนียมศาล
    specifyFee:2//หน้าระบุทุนทรัพย์หรือค่าธรรมเนียมศาล
  },

  suitFeeType:{
    no:0,//ไม่มีธรรมเนียมศาลชำระ
    pay:1,//รวมชำระค่าธรรมเนียม
    seperate:2,//แยกชำระ
    bad:3,//ขอยกเว้นค่าธรรมเนียม
  },

  regisChkDuplicate:{
    no:0,//ไม่ซ้ำ
    idNo:1,//บัตรซ้ำ
    eMail:2,//เมลซ้ำ
    both:3,//บัตร-เมลซ้ำ
  },

  suitTypeSEnum:{
    straight:1,//ฟ้องตรง
    appeal:2,//อุทรธณ์
    petition:3,//คำร้อง
  },

  suitResultEnum:{
    hide:0,
    noData:1,// ไม่พบหมายเลขคดี
    inprogress:2,// คดีอยู่ระหว่างการพิจารณาของศาล
    show:3,// แสดงฐานะให้เลือก
  },

  positionShowTypeEnum:{
    show:1,// แสดงข้อความ
    textBlue:2,// แสดงข้อความตัวหนังสือสีน้ำเงิน
    textRed:3,// แสดงข้อความตัวหนังสือสีแดง
    hide:4,// ไม่แสดง
  },

  suitResultAppealPayFeesEnum:{
    noData:1,// ไม่พบหมายเลขคดี
    noJudgement:2,//คดีนี้ยังไม่มีคําพิพากษา
    notMatch:3,//ท่านไม่ใช่คู่กรณีในคดีนี้
    noRefCode:4,//ไม่พบรหัสอ้างอิงนี้
    canPass:5,//ไปต่อได้
  },

  isAppealEnum:{
    no:0,
    yes:1,
  },

  payStyleEnum:{
    normal:0,
    addtional:1,
    summary:2
  },
  chkTypeCheck: {
    inSql: 1,
    notInSql: 2, 
    allSql: 3
  },
  sectionIDChk: {
    sec01: 1,
    sec02: 2, 
    sec03: 3,
    sec04: 4,
    sec05: 5, 
    sec06: 6,
    sec07: 7,
    sec08: 8, 
    sec09: 9,
    sec10: 10
  },
};